import { Tabs, TabsProps } from 'antd'
import { createStyles } from 'antd-style'

import { TableOfContentsPlugin } from '@eastcoal/editor/plugins/TableOfContentsPlugin'

const useStyles = createStyles(({ token }) => ({
  container: {
    paddingInline: token.padding
  }
}))

const items: TabsProps['items'] = [
  {
    key: 'contents',
    label: '目录',
    children: <TableOfContentsPlugin title='' />
  },
  {
    key: 'variables',
    label: '参数',
    children: null
  }
]

export const LeftPanel = () => {
  const { styles } = useStyles()

  return <Tabs className={styles.container} items={items} />
}
